export * from "./useConsentPopUp";
